import { format } from "colbi_web_ui/lib/utils";

export function convertBytesToMegaBytes(value, precison = 2) {
    if (value) {
        return (value / Math.pow(1024, 2)).toFixed(precison).toString();
    }
    return "N/A";
}

export function adjustForTimezone(date) {
    const adjustedDateTimeZone = new Date(date);
    const timeOffsetInMS = adjustedDateTimeZone.getTimezoneOffset() * 60000;
    return new Date(adjustedDateTimeZone.setTime(adjustedDateTimeZone.getTime() + timeOffsetInMS));
}

export function checkNumberValues(value) {
    if (value && value !== "N/A") {
        return format(value);
    }
    return "N/A";
}

export const formatCurrencyValues = (currencyOptions, value) => {
    const { locale, currency } = JSON.parse(currencyOptions || "{}");
    return locale && currency ? format(value, "normal", currency, 2, locale) : format(value);
};

export function buildNavigationMenu(navigationMenu, i18n) {
    const navigationObj = (navigationMenu || []).reduce((acc, elem) => {
        const { name } = elem || {};
        if (!acc[name]) {
            acc[name] = {
                name: elem.name,
                to: elem.to,
                exact: true,
                icon: elem.icon,
            };
        }
        acc[name]["name"] = i18n`${elem.name}`;
        return Object.values(acc);
    }, []);
    return navigationObj;
}
